export const DeliveryTruck = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27.551"
    height="21.202"
    viewBox="0 0 27.551 21.202"
  >
    <g id="Group_210" data-name="Group 210" transform="translate(-1008 -1011)">
      <path
        id="Path_143"
        data-name="Path 143"
        d="M1017.158,1028.816h7.5v-16.161a1.158,1.158,0,0,0-1.154-1.154h-13.853a1.158,1.158,0,0,0-1.154,1.154v16.161h2.886"
        fill="none"
        stroke="#a2a4be"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Path_144"
        data-name="Path 144"
        d="M1031.158,1027.89h1.732V1024.5a1.155,1.155,0,0,0-.438-.9l-3.025-1.478-.519-3.59a1.142,1.142,0,0,0-1.143-1.027H1022.5v10.39h2.886"
        transform="translate(2.161 0.926)"
        fill="none"
        stroke="#a2a4be"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <circle
        id="Ellipse_22"
        data-name="Ellipse 22"
        cx="2.886"
        cy="2.886"
        r="2.886"
        transform="translate(1027.547 1025.93)"
        fill="none"
        stroke="#a2a4be"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
      <circle
        id="Ellipse_23"
        data-name="Ellipse 23"
        cx="2.886"
        cy="2.886"
        r="2.886"
        transform="translate(1011.386 1025.93)"
        fill="none"
        stroke="#a2a4be"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export const GreenProduct = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="24"
    viewBox="0 0 21 24"
  >
    <g id="Group_346" data-name="Group 346" transform="translate(-913 -192)">
      <path
        id="Path_238"
        data-name="Path 238"
        d="M925.5,194.5c0,1.1-2,4-2,4s-2-2.9-2-4a2,2,0,0,1,4,0Z"
        fill="none"
        stroke="#b1dfd7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Path_239"
        data-name="Path 239"
        d="M918.5,197.5c1.1,0,4,2,4,2s-2.9,2-4,2a2,2,0,0,1,0-4Z"
        fill="none"
        stroke="#b1dfd7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Path_240"
        data-name="Path 240"
        d="M921.5,204.5c0-1.1,2-4,2-4s2,2.9,2,4a2,2,0,0,1-4,0Z"
        fill="none"
        stroke="#b1dfd7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Path_241"
        data-name="Path 241"
        d="M928.5,201.5c-1.1,0-4-2-4-2s2.9-2,4-2a2,2,0,0,1,0,4Z"
        fill="none"
        stroke="#b1dfd7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Path_242"
        data-name="Path 242"
        d="M923.5,215.5c2-7,4-10,10-10C929.5,211.5,929.5,215.5,923.5,215.5Z"
        fill="none"
        stroke="#b1dfd7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Path_243"
        data-name="Path 243"
        d="M923.5,215.5c-2-7-4-10-10-10C917.5,211.5,917.5,215.5,923.5,215.5Z"
        fill="none"
        stroke="#b1dfd7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export const Bin = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.001"
    height="19.693"
    viewBox="0 0 16.001 19.693"
  >
    <path
      id="Icon_metro-bin"
      data-name="Icon metro-bin"
      d="M5.73,8.082V20.39A1.234,1.234,0,0,0,6.96,21.621H18.038a1.234,1.234,0,0,0,1.231-1.231V8.082H5.73ZM9.422,19.159H8.191V10.544H9.422Zm2.462,0H10.653V10.544h1.231Zm2.462,0H13.114V10.544h1.231Zm2.462,0H15.576V10.544h1.231ZM19.576,4.39h-4V2.851a.926.926,0,0,0-.923-.923H10.345a.926.926,0,0,0-.923.923V4.39h-4a.926.926,0,0,0-.923.923V6.851h16V5.313A.926.926,0,0,0,19.576,4.39Zm-5.231,0H10.653V3.174h3.692V4.39Z"
      transform="translate(-4.499 -1.928)"
      fill="#c5cacf"
    />
  </svg>
);
